import httpRequest from "@/core/http-request"

//权限相关API数据请求
export const permissionApi = {
    savePermission(data){
        return httpRequest.post('/permission/save', data)
    },
    getPermissionsPage(){
        return httpRequest.get('/permission/list')
    },

    deletePermission(ids){
        return httpRequest.post('/permission/delete', ids)
    }
}